import $ from "jquery";
import axios from "axios";

$(document).on("keypress", ".NumbersOnly", function(e) {
    var NewYeyCode = !e.keyCode ? e.which : e.keyCode;
    //alert(NewYeyCode);
    if ((NewYeyCode != 8) && (NewYeyCode != 13)) {
        var regex = new RegExp("^[0-9]+$");
        var key = String.fromCharCode(NewYeyCode);
        if (!regex.test(key)) {
            e.preventDefault();
            return false;
        }
    }
});

$(document).on("keyup", ".NumbersOnly", function(e) {
    var NewYeyCode = !e.keyCode ? e.which : e.keyCode;
    //alert(NewYeyCode);
    if ((NewYeyCode != 17) && (NewYeyCode != 65) && (NewYeyCode != 35) && (NewYeyCode != 36) && (NewYeyCode != 37) && (NewYeyCode != 39)) {
        var regexp = (/[^0-9]/g);
        if (regexp.test(this.value)) {
            this.value = this.value.replace(regexp, "");
        }
    }
});

$(document).on("keypress", ".FloatsOnly", function(e) {
    var NewKeyCode = !e.keyCode ? e.which : e.keyCode;
    //alert(NewKeyCode);
    if ((NewKeyCode != 8) && (NewKeyCode != 13)) {
        var regex = new RegExp("^[0-9.]+$");
        var key = String.fromCharCode(NewKeyCode);
        if (!regex.test(key)) {
            e.preventDefault();
            return false;
        }
    }
});

$(document).on("keyup", ".FloatsOnly", function(e) {
    var NewKeyCode = !e.keyCode ? e.which : e.keyCode;
    //alert(NewKeyCode);
    if ((NewKeyCode != 17) && (NewKeyCode != 65) && (NewKeyCode != 35) && (NewKeyCode != 37) && (NewKeyCode != 39)) {
        var regexp = (/[^0-9.]/g);
        if (regexp.test(this.value)) {
            this.value = this.value.replace(regexp, "");
        }
    }
});

$(".NoSpaces").on({
    keydown: function(e) {
        if (e.which === 32) {
            return false;
        }
    },
    change: function() {
        this.value = this.value.replace(/\s/g, "");
    }
});

$(document).on("change", 'input[type="text"]', function(e) {
    this.value = $.trim(this.value);
});

function getStepNumber(data_active) {
    var step = 0;
    if (data_active === "active-1") {
        step = 1;
    } else if (data_active === "active-2") {
        step = 2;
    } else if (data_active === "active-3") {
        step = 3;
    } else if (data_active === "active-4") {
        step = 4;
    }
    return step;
}

function loadExactStep(step) {
    var data_active = "active-";
    // if (step == 1) {
    //     data_active += "one";
    // } else if (step == 2) {
    //     data_active += "two";
    // } else if (step == 3) {
    //     data_active += "three";
    // } else if (step == 4) {
    //     data_active += "four";
    // }
    data_active += step;
    // console.log("data_active", data_active);

    $(".rebate-form-page .form-container .numbering ul li label").removeClass("active");
    $(".rebate-form-page .form-container .numbering ul li label[data-active=" + data_active + "]").addClass("active");
    $(".rebate-form-page .form-container form .inner-content").removeClass("active");
    $(".rebate-form-page .form-container form .inner-content[data-active=" + data_active + "]").addClass("active");
    $(".rebate-form-page .form-container form .submit-container .form-submit-button").removeClass("active");
    $(".rebate-form-page .form-container form .submit-container .form-submit-button[data-active=" + data_active + "]").addClass("active");
    $(".rebate-form-page .form-container form .submit-container .form-previous-button").removeClass("active");
    if (data_active !== "active-1") {
        $(".rebate-form-page .form-container form .submit-container .form-previous-button[data-active=" + data_active + "]").addClass("active");
    }

    var firstErrorLabel = null;
    $("label.error").each(function () {
        if ($(this).text().trim() !== "") {
            firstErrorLabel = $(this);
            return false;
        }
    });
    if (firstErrorLabel !== null) {
        firstErrorLabel.removeClass("valid").addClass("error");
        window.scrollTo({top: firstErrorLabel.offset().top - 100, behavior: "smooth"});
    }
}

function validateErrors(errors, step = 0) {
    if (typeof errors == "object") {
        $.each(errors, function(key, value) {
            // console.log(key);
            // console.log(value);
            if (key.indexOf(".") !== -1) {
                var keySplit = key.split(".");
                var keyName = keySplit[0];
                var keyIndex = keySplit[1];
                var inputNameIndex = $('input[name="' + keyName + '[]"]:eq(' + keyIndex + ')');
                var label = inputNameIndex.next("label");
                if (label.length > 0) {
                    label.removeClass("valid").addClass("error");
                }
            }
            if ($("#" + key).length > 0) {
                $("#" + key).removeClass("valid").addClass("error");
            }
            if ($("#" + key + "_ajax").length > 0) {
                $("#" + key + "_ajax").removeClass("valid").addClass("error");
            }
            if ((typeof value === "object") && value.length > 1) {
                // console.log("value object", value.length);
                let alertMsg = "";
                $.each(value, function(key1, value1) {
                    alertMsg += value1 + "<br />";
                });
                if (key.indexOf(".") !== -1) {
                    if (label.length > 0) {
                        label.html(alertMsg).show();
                    }
                }
                if ($("#" + key + "-error").length > 0) {
                    $("#" + key + "-error").html(alertMsg).show();
                }
                if ($("#" + key + "_ajax-error").length > 0) {
                    $("#" + key + "_ajax-error").html(alertMsg).show();
                }
                if ($("#" + key).length > 0) {
                    $("#" + key).removeClass("valid").addClass("error");
                }
                if ($("#" + key + "_ajax").length > 0) {
                    $("#" + key + "_ajax").removeClass("valid").addClass("error");
                }
            } else if (typeof value === "object") {
                // console.log("value string", value);
                if (key.indexOf(".") !== -1) {
                    if (label.length > 0) {
                        label.html(value[0]).show();
                    }
                }
                if ($("#" + key + "-error").length > 0) {
                    $("#" + key + "-error").html(value[0]).show();
                }
                if ($("#" + key + "_ajax-error").length > 0) {
                    $("#" + key + "_ajax-error").html(value[0]).show();
                }
                if ($("#" + key).length > 0) {
                    $("#" + key).removeClass("valid").addClass("error");
                }
                if ($("#" + key + "_ajax").length > 0) {
                    $("#" + key + "_ajax").removeClass("valid").addClass("error");
                }
            }
        });
        if (step > 0) {
            loadExactStep(step);
        }
    }
}

function submitAjaxForm(form, btn) {
    var form_data = new FormData();
    var other_data = form.serializeArray();
    $.each(other_data, function (key, input) {
        if ((input.name == "oldPassword") || (input.name == "password") || (input.name == "password_confirmation")) {
            input.value = md5(input.value);
        }
        form_data.append(input.name, input.value);
        // console.log(input.name + ":   " + input.value);
    });
    $.each(form.find("input[type=file]"), function(i, obj) {
        var file_name = $(this).attr("name");
        if (typeof obj.files[0] !== typeof undefined) {
            form_data.append(file_name, obj.files[0]);
            // console.log(file_name, obj.files[0]);
        }
    });
    // var currentStep = getStepNumber(getActiveStep());
    var currentStep = getStepNumber(btn.data("active"));
    // console.log("currentStep", currentStep);
    form_data.append("step", currentStep);
    var formUuid = localStorage.getItem(form.attr("name") + "-uuid");
    if (formUuid) {
        form_data.append("uuid", formUuid);
    }
    axios.post(form.attr("action"), form_data)
    .then(function(response) {
        // console.log(response.data);
        var lsFormUUID = "";
        var lsFormStep = "";
        if (!$.isEmptyObject(response) && (response.data.name)) {
            lsFormUUID = response.data.name;
            lsFormStep = response.data.name;
        }
        lsFormUUID += "-uuid";
        lsFormStep += "-step";
        if (!$.isEmptyObject(response) && (response.data.validation_errors)) {
            var step = 0;
            if (!$.isEmptyObject(response) && (response.data.step)) {
                step = response.data.step;
            }
            validateErrors(response.data.validation_errors, step);
            btn.css("pointer-events", "auto");
            btn.find(".spinner").css("display", "none");
            btn.html('<span>' + btn.data("text-en") + '</span><span class="spinner"></span><span>' + btn.data("text-ar") + '</span>');
            $(".pleaseWaitMoment").fadeOut();
        } else if (response.data.success == true) {
            if (!$.isEmptyObject(response) && (response.data.completed) && (response.data.completed == true)) {
                localStorage.removeItem(lsFormUUID);
                localStorage.removeItem(lsFormStep);
                // localStorage.clear();
                // $("#responseSuccessMessage").css("display", "inline").html(response.data.message);
                $("html, body").animate({ scrollTop: "0" }, 1000, "swing");
                setInterval(function() {
                    $("#rebateForm").remove();
                }, 100);
                $(".rebate-form-page .form-container .thank-you-container").delay(100).css("display", "flex").hide().fadeIn();
            } else {
                if (!$.isEmptyObject(response) && (response.data.uuid)) {
                    localStorage.setItem(lsFormUUID, response.data.uuid);
                    if ($("#uuid").length == 0) {
                        var UuidHiddenInput = $("<input>")
                            .attr("type", "hidden")
                            .attr("id", "uuid")
                            .attr("name", "uuid")
                            .val(response.data.uuid);
                        $("#rebateForm").prepend(UuidHiddenInput);
                    }
                }
                if (!$.isEmptyObject(response) && (response.data.step)) {
                    localStorage.setItem(lsFormStep, response.data.step);
                    loadExactStep(response.data.step);
                }
            }
            btn.css("pointer-events", "auto");
            btn.find(".spinner").css("display", "none");
            btn.html('<span>' + btn.data("text-en") + '</span><span class="spinner"></span><span>' + btn.data("text-ar") + '</span>');
            $(".pleaseWaitMoment").fadeOut();
        } else {
            if (!$.isEmptyObject(response) && (response.data.step)) {
                loadExactStep(response.data.step);
            }
            $("#responseErrorMessage").css("display", "inline").html(response.data.message);
            btn.css("pointer-events", "auto");
            btn.find(".spinner").css("display", "none");
            btn.html('<span>' + btn.data("text-en") + '</span><span class="spinner"></span><span>' + btn.data("text-ar") + '</span>');
            $(".pleaseWaitMoment").fadeOut();
        }
    })
    .catch(function(error) {
        $("#responseErrorMessage").css("display", "inline").html(trans("Please Try again later."));
        btn.css("pointer-events", "auto");
        btn.find(".spinner").css("display", "none");
        btn.html('<span>' + btn.data("text-en") + '</span><span class="spinner"></span><span>' + btn.data("text-ar") + '</span>');
        $(".pleaseWaitMoment").fadeOut();
    });
}

function previewSubmitAjaxForm(form, btn) {
    var step = getStepNumber(btn.data("active"));
    if (!step) {
        step = 1;
    }
    // console.log("step", step);
    var countSteps = $(".rebate-form-page .form-container .left .numbering.preview ul li").length;
    // console.log("countSteps", countSteps);
    if (step < countSteps) {
        step++;
    }
    
    var data_active = "active-";
    data_active += step;
    // console.log("data_active", data_active);

    $(".rebate-form-page .form-container .numbering.preview ul li label").removeClass("active");
    $(".rebate-form-page .form-container .numbering.preview ul li label[data-active=" + data_active + "]").addClass("active");
    $(".rebate-form-page .form-container form .inner-content-preview").removeClass("active");
    $(".rebate-form-page .form-container form .inner-content-preview[data-active=" + data_active + "]").addClass("active");
    $(".rebate-form-page .form-container form .submit-container .form-submit-button-preview").removeClass("active");
    $(".rebate-form-page .form-container form .submit-container .form-submit-button-preview[data-active=" + data_active + "]").addClass("active");
    $(".rebate-form-page .form-container form .submit-container .form-previous-button-preview").removeClass("active");
    if (data_active !== "active-1") {
        $(".rebate-form-page .form-container form .submit-container .form-previous-button-preview[data-active=" + data_active + "]").addClass("active");
    }

    $("#rebateModalBody").animate({ scrollTop: 0 }, "slow");
}

function saveAjaxForm(form, btn) {
    var form_data = new FormData();
    var other_data = form.serializeArray();
    $.each(other_data, function (key, input) {
        if ((input.name == "oldPassword") || (input.name == "password") || (input.name == "password_confirmation")) {
            input.value = md5(input.value);
        }
        form_data.append(input.name, input.value);
        // console.log(input.name + ":   " + input.value);
    });
    $.each(form.find("input[type=file]"), function(i, obj) {
        var file_name = $(this).attr("name");
        if (typeof obj.files[0] !== typeof undefined) {
            form_data.append(file_name, obj.files[0]);
            // console.log(file_name, obj.files[0]);
        }
    });
    var currentStep = getStepNumber(getActiveStep());
    // console.log("currentStep", currentStep);
    form_data.append("step", currentStep);
    var formUuid = localStorage.getItem(form.attr("name") + "-uuid");
    if (formUuid) {
        form_data.append("uuid", formUuid);
    }
    axios.post(form.attr("action") + "/save", form_data)
    .then(function(response) {
        // console.log(response.data);
        var lsFormUUID = "";
        var lsFormStep = "";
        if (!$.isEmptyObject(response) && (response.data.name)) {
            lsFormUUID = response.data.name;
            lsFormStep = response.data.name;
        }
        lsFormUUID += "-uuid";
        lsFormStep += "-step";
        if (response.data.success == true) {
            if (!$.isEmptyObject(response) && (response.data.uuid)) {
                localStorage.setItem(lsFormUUID, response.data.uuid);
                if ($("#uuid").length == 0) {
                    var UuidHiddenInput = $("<input>")
                        .attr("type", "hidden")
                        .attr("id", "uuid")
                        .attr("name", "uuid")
                        .val(response.data.uuid);
                    $("#rebateForm").prepend(UuidHiddenInput);
                }
            }
            if (!$.isEmptyObject(response) && (response.data.step)) {
                localStorage.setItem(lsFormStep, response.data.step);
            }
            $("#copyBtn").css("display", "inline-flex");
            $("#saveBtn").css("display", "none");
            $(".pleaseWaitMoment").fadeOut();
            $(".pleaseWaitMoment.copyLink").fadeIn();
        } else {
            $("#responseErrorMessage").css("display", "inline").html(response.data.message);
        }
        btn.css("pointer-events", "auto");
        btn.find(".spinner").css("display", "none");
        btn.html('<span>' + btn.data("text-en") + '</span><span class="spinner"></span><span>' + btn.data("text-ar") + '</span>');
    })
    .catch(function(error) {
        $("#responseErrorMessage").css("display", "inline").html(trans("Please Try again later."));
        btn.css("pointer-events", "auto");
        btn.find(".spinner").css("display", "none");
        btn.html('<span>' + btn.data("text-en") + '</span><span class="spinner"></span><span>' + btn.data("text-ar") + '</span>');
        $(".pleaseWaitMoment").fadeOut();
    });
}

function generateUniqueFormUuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
        v = c === "x" ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function isUUID(str) {
    var uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return uuidRegex.test(str);
}

function removeLastSegment(url) {
    var urlParts = url.split("/");
    var lastSegment = urlParts.pop();
    if (urlParts.length > 2) {
        return urlParts.join("/");
    } else {
        return urlParts.join("");
    }
}

function getActiveStep() {
    var activeInnerContent = $(".inner-content.active");
    var saveBtn = $("#saveBtn");
    if ((activeInnerContent.length > 0) && (saveBtn.length > 0)) {
        var dataActive = activeInnerContent.data("active");
        saveBtn.attr("data-active", dataActive);
        return dataActive;
    }
    return "active-1";
}

function selectFuncForFiles(thisFile, type, fileContainer) {
    var model_id = 0;
    var input_file_name = "";
    var input_file_value = "";
    var mediaid = "";
    var href = "";
    var isRequired = 0;
    var file_accept = "";
    var isMultiple = 0;
    var special = "";
    var max_size = 0;

    if (fileContainer.data("id") && (fileContainer.data("id") != "")) {
        model_id = fileContainer.data("id");
    }
    if (fileContainer.data("name") && (fileContainer.data("name") != "")) {
        input_file_name = fileContainer.data("name");
    }
    if (fileContainer.data("value") && (fileContainer.data("value") != "")) {
        input_file_value = fileContainer.data("value");
    }
    if (fileContainer.data("mediaid") && (fileContainer.data("mediaid") != "")) {
        mediaid = fileContainer.data("mediaid");
    }
    if (fileContainer.data("href") && (fileContainer.data("href") != "")) {
        href = fileContainer.data("href");
    }
    if (fileContainer.data("required") && (fileContainer.data("required") != "")) {
        isRequired = fileContainer.data("required");
    }
    if (fileContainer.data("accept") && (fileContainer.data("accept") != "")) {
        file_accept = fileContainer.data("accept");
    }
    if (fileContainer.data("multiple") && (fileContainer.data("multiple") != "")) {
        isMultiple = fileContainer.data("multiple");
    }
    special = fileContainer.data("special");
    if (special === undefined) {
        special = "";
    }
    if (fileContainer.data("max-size") && (fileContainer.data("max-size") != "")) {
        max_size = fileContainer.data("max-size");
    }
    thisFile.parent().find("label.error").html("");
    thisFile.parent().find("label.error").hide();
    UploadOrDeleteFormFile(thisFile, type, fileContainer, model_id, input_file_name, input_file_value, mediaid, href, isRequired, file_accept, isMultiple, special, max_size);
}

function UploadOrDeleteFormFile(thisFile, type, fileContainer, model_id, input_file_name, input_file_value, mediaid, href, isRequired, file_accept, isMultiple, special, max_size) {
    const loading = fileContainer.find(".loading");
    if (loading.length) {
        loading.show();
    }
    var step = 1;
    var icon_download = "";
    var icon_delete = "";
    var icon_upload = "";
    if (fileContainer.data("step") && (fileContainer.data("step") != "")) {
        step = fileContainer.data("step");
    }
    if (fileContainer.data("icon-download") && (fileContainer.data("icon-download") != "")) {
        icon_download = fileContainer.data("icon-download");
    }
    if (fileContainer.data("icon-delete") && (fileContainer.data("icon-delete") != "")) {
        icon_delete = fileContainer.data("icon-delete");
    }
    if (fileContainer.data("icon-upload") && (fileContainer.data("icon-upload") != "")) {
        icon_upload = fileContainer.data("icon-upload");
    }
    // console.log("model_id", model_id);
    // console.log("input_file_name", input_file_name);
    // console.log("input_file_value", input_file_value);
    // console.log("mediaid", mediaid);
    // console.log("href", href);
    // console.log("isRequired", isRequired);
    // console.log("file_accept", file_accept);
    // console.log("isMultiple", isMultiple);
    // console.log("special", special);
    // console.log("max_size", max_size);

    var form_data = new FormData();
    form_data.append("step", step);
    form_data.append("g-recaptcha-response", $("#g-recaptcha-response_ajax").val());
    form_data.append("model_id", model_id);
    form_data.append("input_file_name", input_file_name);
    if (type === "upload") {
        // console.log("type", type);

        form_data.append("uploadFiles", true);
        var fileInput = thisFile[0];
        var files = fileInput.files;
        if (typeof files[0] !== typeof undefined) {
            form_data.append(input_file_name, files[0]);
            // console.log(input_file_name, files[0]);
        }
        var formUuid = localStorage.getItem($("#rebateForm").attr("name") + "-uuid");
        if (formUuid) {
            form_data.append("uuid", formUuid);
        } else {
            form_data.append("uuid", generateUniqueFormUuid());
        }
        axios.post($("#rebateForm").attr("action"), form_data)
        .then(function(response) {
            // console.log(response.data);
            if (response.data.success == true) {
                if (!$.isEmptyObject(response) && (response.data.uuid) && ($("#uuid").length == 0)) {
                    var UuidHiddenInput = $("<input>")
                        .attr("type", "hidden")
                        .attr("id", "uuid")
                        .attr("name", "uuid")
                        .val(response.data.uuid);
                    $("#rebateForm").prepend(UuidHiddenInput);
                }
                if (!$.isEmptyObject(response) && (response.data.step)) {
                    step = response.data.step;
                    fileContainer.attr("data-step", step);
                }
                if (!$.isEmptyObject(response) && (response.data.dataValue)) {
                    input_file_value = response.data.dataValue;
                    fileContainer.attr("data-value", input_file_value);
                }
                if (!$.isEmptyObject(response) && (response.data.dataMediaId)) {
                    mediaid = response.data.dataMediaId;
                    fileContainer.attr("data-mediaid", mediaid);
                }
                if (!$.isEmptyObject(response) && (response.data.dataHref)) {
                    href = response.data.dataHref;
                    fileContainer.attr("data-href", href);
                }
                if (!$.isEmptyObject(response) && (response.data.RAFKeySupplierInformationId)) {
                    var trRow = fileContainer.parent().parent().parent();
                    if (trRow.length > 0) {
                        trRow.find("input[name='ksi_[]']").val(response.data.RAFKeySupplierInformationId);
                    }
                }
                var returnedHTML = '';
                returnedHTML += '\
                <label class="file" for="' + input_file_name;
                if (special !== "") {
                    returnedHTML += "_" + special;
                }
                returnedHTML += '">';
                returnedHTML += '\
                    <a href="' + input_file_value + '">\
                        <span>\
                            <img src="' + icon_download + '" alt="Download" />\
                        </span>\
                        <span class="download">\
                            Download / تحميل\
                        </span>\
                    </a>\
                    <span>\
                        &nbsp;\
                        &nbsp;\
                        |\
                        &nbsp;\
                        &nbsp;\
                    </span>\
                    <span class="deleteFile">\
                        <img src="' + icon_delete + '" alt="Delete" />\
                    </span>\
                </label>';

                returnedHTML += '\
                    <label id="' + input_file_name;
                if (special !== "") {
                    returnedHTML += "_" + special;
                }
                returnedHTML += '-error" class="error" for="' + input_file_name;
                if (special !== "") {
                    returnedHTML += "_" + special;
                }
                returnedHTML += '"></label>';
                returnedHTML += '\
                <div class="loading"><span class="spinner"></span></div>';
                fileContainer.html(returnedHTML);
                if (isMultiple == 1) {
                    isRequired = 0;
                    var returnedHTML2 = '';
                    returnedHTML2 += '<br />\
                    <div class="fileContainer"';
                        returnedHTML2 += ' data-id="0"';
                        returnedHTML2 += ' data-step="' + step + '"';
                        returnedHTML2 += ' data-icon-download="' + icon_download + '"';
                        returnedHTML2 += ' data-icon-delete="' + icon_delete + '"';
                        returnedHTML2 += ' data-icon-upload="' + icon_upload + '"';
                        returnedHTML2 += ' data-name="' + input_file_name + '"';
                        returnedHTML2 += ' data-required="' + isRequired + '"';
                        returnedHTML2 += ' data-accept="' + file_accept + '"';
                        if (isMultiple == 1) {
                            returnedHTML2 += ' data-multiple="' + isMultiple + '"';
                        }
                        if (special !== "") {
                            returnedHTML2 += ' data-special="' + special + '"';
                        }
                        returnedHTML2 += ' data-max-size="' + max_size + '"';
                        returnedHTML2 += '>';

                        returnedHTML2 += '\
                        <label class="file cursor" for="' + input_file_name;
                        if (special !== "") {
                            returnedHTML2 += "_" + special;
                        }
                        returnedHTML2 += '">';
                        returnedHTML2 += '\
                            <img src="' + icon_upload + '" alt="Upload" />\
                            <span class="upload">Upload / تحميل</span>\
                        </label>\
                        <input type="file"';
                        // if (isMultiple == 1) {
                        //     returnedHTML2 += ' multiple';
                        // }
                        returnedHTML2 += ' id="' + input_file_name;
                        if (special !== "") {
                            returnedHTML2 += "_" + special;
                        }
                        returnedHTML2 += '" name="' + input_file_name;
                        if ((isMultiple == 1) || (special !== "")) {
                            returnedHTML2 += "[]";
                        }
                        returnedHTML2 += '" class="fileUpload" accept="' + file_accept + '" data-max-size="' + max_size + '"';
                        if (isRequired) {
                            returnedHTML2 += " required";
                        }
                        returnedHTML2 += " />";

                        returnedHTML2 += '\
                            <label id="' + input_file_name;
                        if (special !== "") {
                            returnedHTML2 += "_" + special;
                        }
                        returnedHTML2 += '-error" class="error" for="' + input_file_name;
                        if (special !== "") {
                            returnedHTML2 += "_" + special;
                        }
                        returnedHTML2 += '"></label>';
                        returnedHTML2 += '\
                        <div class="loading"><span class="spinner"></span></div>\
                    </div>';
                    fileContainer.after(returnedHTML2);
                }
            } else if (!$.isEmptyObject(response) && (response.data.validation_errors)) {
                var step = 0;
                if (!$.isEmptyObject(response) && (response.data.step)) {
                    step = response.data.step;
                }
                validateErrors(response.data.validation_errors, step);
            }
            if (loading.length) {
                loading.hide();
            }
        })
        .catch(function(error) {
            if (loading.length) {
                loading.hide();
            }
        });
    } else if (type === "delete") {
        if (confirm(trans("Are you sure you want to delete it?"))) {
            form_data.append("deleteFiles", true);
            var formUuid = localStorage.getItem($("#rebateForm").attr("name") + "-uuid");
            if (formUuid) {
                form_data.append("uuid", formUuid);
            }
            form_data.append("mediaid", mediaid);
            axios.post($("#rebateForm").attr("action"), form_data)
            .then(function(response) {
                // console.log(response.data);
                if (response.data.success == true) {
                    if (isMultiple == 1) {
                        fileContainer.next("br").remove();
                        fileContainer.remove();
                    } else {
                        fileContainer.attr("data-value", "");
                        fileContainer.attr("data-mediaid", "");
                        fileContainer.attr("data-href", "");

                        var returnedHTML = '';
                        returnedHTML += '\
                        <label class="file cursor" for="' + input_file_name;
                        if (special !== "") {
                            returnedHTML += "_" + special;
                        }
                        returnedHTML += '">';
                        returnedHTML += '\
                            <img src="' + icon_upload + '" alt="Upload" />\
                            <span class="upload">Upload / تحميل</span>\
                        </label>\
                        <input type="file"';
                        // if (isMultiple == 1) {
                        //     returnedHTML += ' multiple';
                        // }
                        returnedHTML += ' id="' + input_file_name;
                        if (special !== "") {
                            returnedHTML += "_" + special;
                        }
                        returnedHTML += '" name="' + input_file_name;
                        if ((isMultiple == 1) || (special !== "")) {
                            returnedHTML += "[]";
                        }
                        returnedHTML += '" class="fileUpload" accept="' + file_accept + '" data-max-size="' + max_size + '"';
                        if (isRequired) {
                            returnedHTML += " required";
                        }
                        returnedHTML += " />";

                        returnedHTML += '\
                            <label id="' + input_file_name;
                        if (special !== "") {
                            returnedHTML += "_" + special;
                        }
                        returnedHTML += '-error" class="error" for="' + input_file_name;
                        if (special !== "") {
                            returnedHTML += "_" + special;
                        }
                        returnedHTML += '"></label>';
                        returnedHTML += '\
                        <div class="loading"><span class="spinner"></span></div>';
                        fileContainer.html(returnedHTML);
                    }
                    var fileContainerCount = $('input[name="thirdparty_vendor_crew_contracts[]"]').parent().parent().find(".fileContainer").length;
                    // console.log("Input count:", fileContainerCount);
                    if (fileContainerCount === 1) {
                        $('input[name="thirdparty_vendor_crew_contracts[]"]').attr("required", true);
                    }
                }
                if (loading.length) {
                    loading.hide();
                }
            })
            .catch(function(error) {
                if (loading.length) {
                    loading.hide();
                }
            });
        } else {
            if (loading.length) {
                loading.hide();
            }
        }
    }
}

function getBaseUrl() {
    var url = window.location.href;
    var baseUrl = url.split("?")[0];
    return baseUrl;
}

export {getStepNumber, loadExactStep, validateErrors, submitAjaxForm, previewSubmitAjaxForm, saveAjaxForm, generateUniqueFormUuid, isUUID, removeLastSegment, getActiveStep, selectFuncForFiles, UploadOrDeleteFormFile, getBaseUrl}
